export default __webpack_public_path__ + "static/media/login-background.42390b73.jpg";